// extracted by mini-css-extract-plugin
export default {"heading1":"Heading_heading1__cLOVw","heading2":"Heading_heading2__d0zi0","centred":"Heading_centred__FCquR","inverse":"Heading_inverse__z6aIK"};